import { startOfWeek } from 'date-fns/startOfWeek';
import { IDateInterval } from '../interfaces/i-date-interval';
import { startOfMonth } from 'date-fns/startOfMonth';
import { endOfMonth } from 'date-fns/endOfMonth';
import { startOfYear } from 'date-fns/startOfYear';
import { addWeeks } from 'date-fns/addWeeks';
import { addMonths } from 'date-fns/addMonths';
import { addYears } from 'date-fns/addYears';
import { endOfYear } from 'date-fns/endOfYear';
import { endOfWeek } from 'date-fns/endOfWeek';

export const predefinedDateIntervals: IDateInterval[] = [
  { label: 'This week', from: startOfWeek(Date.now(), { weekStartsOn: 0 }), to: endOfWeek(Date.now(), { weekStartsOn: 0 }) },
  { label: 'This month', from: startOfMonth(Date.now()), to: endOfMonth(Date.now()) },
  { label: 'This year', from: startOfYear(Date.now()), to: endOfYear(Date.now()) },
  { label: 'This year to date', from: startOfYear(Date.now()), to: new Date() },
  { label: 'Last week', from: addWeeks(startOfWeek(Date.now(), { weekStartsOn: 0 }), -1), to: addWeeks(endOfWeek(Date.now(), { weekStartsOn: 0 }), -1) },
  { label: 'Last month', from: addMonths(startOfMonth(Date.now()), -1), to: endOfMonth(addMonths(startOfMonth(Date.now()), -1)) },
  { label: 'Last year', from: addYears(startOfYear(Date.now()), -1), to: endOfYear(addYears(startOfYear(Date.now()), -1)) },
  { label: 'Last year to date', from: addYears(startOfYear(Date.now()), -1), to: addYears(new Date(), -1) },
  { label: '10 years to date', from: addYears(startOfYear(Date.now()), -10), to: new Date() },
];
